/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { components } from 'react-select';
import { MdExpandMore } from 'react-icons/md';

const DropdownIndicator: React.FC = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <MdExpandMore size={20} />
    </components.DropdownIndicator>
  );
};

export default DropdownIndicator;
